<template>
  <div class="layout-footer">
    <p>Copyright &copy; 2009 - 2010 WIRELESS HG SOLUTION. All rights reserved</p>
    <ul class="categories pc">
      <li @click="menuFilter(-1, -1)" :class="{active: currItem == -1}">All</li>
      <li v-for="(item, index) in brandList" @click="menuFilter(index, item.cid)" :class="{active: currItem == index}">{{item.cname}}</li>
    </ul>
  </div>
</template>
<script>
import {GetProductList} from '@/api/index.js'
  export default {
    name: 'LayoutFooter',
    data() {
      return {
        category:null,
        curpage:1,
        bid:null,
        cid:null,
        keyword:null,
        currItem: -1,
        brandList:null,
      };
    },
    created(){
      this.initData();
    },
    methods:{
      initData(){
        // this.loading = true;
        GetProductList({'page_no':this.curpage,'sort_field':'price','sort':'asc','cid':this.cid,'brand_id':this.bid,'keyword':this.keyword})
        .then(res => {
          this.category = res.data.category;
          this.brandList = res.data.brand_list;
          // this.loading = false;
        })
      },
      menuFilter: function(index, bid){
        // this.showMore = false;
        this.currItem = index;

        this.$parent.menuFilter(bid, null)
      },
    }
  };
</script>
<style lang="" scoped>
  .pc{
    display: block;
  }
  .layout-footer{
    width: 100%;
    margin: 0 auto;
    background: #3c4245;
    /* min-height: 100px; */
    color:#eee;
    padding:30px 0;
  }
  p{
    font-size: 15px;
    margin: 0 auto;
    margin-bottom: 10px;
    word-wrap: break-word;
    width: 88%;
  }
  ul{
    list-style-type: none;
  }
  ul li{
    display: inline-block;
    /* padding: 0 20px; */
    margin-left: 30px;
    letter-spacing: 1px;
    font-size: 14px;
    line-height: 23px;
    border-radius: 15px;
  }
  li:first-child{
    margin-left: 0;
  }
  li:hover{
    cursor: pointer;
  }

  @media screen and (max-width:900px){
    .pc{display:none;}
  }
</style>



// WEBPACK FOOTER //
// src/components/Layouts/LayoutFooter.vue